import { formatPrice } from '../shared/currency';
import { MK_FOUR_WEEKS_2999_ONE_WEEK_899_TRIAL_PLAN, MK_FOUR_WEEKS_2999_WITHOUT_TRIAL_PLAN, MK_TWELVE_WEEKS_5999_WITHOUT_TRIAL_PLAN } from '../shared/subscription-plans';
import { parseSolutionFromCreative } from '../shared/ad-helpers';

const subscriptionMapping = {
    [MK_FOUR_WEEKS_2999_ONE_WEEK_899_TRIAL_PLAN]: {
        name: '1-Week Plan'
    },
    [MK_FOUR_WEEKS_2999_WITHOUT_TRIAL_PLAN]: {
        name: '4-week plan',
        isPopular: true
    },
    [MK_TWELVE_WEEKS_5999_WITHOUT_TRIAL_PLAN]: {
        name: '12-week plan'
    }
};

const DAYS_IN_MONTH = 30;
const DAYS_IN_WEEK = 7;

const getPricePerDay = ({ billingPeriod, price }) => {
    if (billingPeriod.unit && billingPeriod.unit === 'week') {
        return Math.round(price / (DAYS_IN_WEEK * Number(billingPeriod.value)));
    }

    return Math.round(price / DAYS_IN_MONTH);
};

const subscriptionPlanMapper = {
    toDomain(subscriptionData) {
        const data = subscriptionMapping[subscriptionData.plan];

        if (!data) {
            return null;
        }

        return {
            name: data.name,
            isPopular: data.isPopular,
            price: formatPrice(subscriptionData.price, subscriptionData.currency),
            pricePerDay: getPricePerDay(subscriptionData),
            billingPeriod: subscriptionData.billingPeriod,
            plan: subscriptionData.plan,
            creative: subscriptionData.creative,
            solution: parseSolutionFromCreative(subscriptionData.creative),
            trial: subscriptionData.trial
                ? {
                    ...subscriptionData.trial,
                    price: formatPrice(subscriptionData.trial.price, subscriptionData.trial.currency),
                    pricePerDay: getPricePerDay({ price: subscriptionData.trial.price, billingPeriod: subscriptionData.trial.billingPeriod })
                }
                : null
        };
    }
};

export {
    subscriptionPlanMapper
};
